import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-content-layout',
    templateUrl: './content-layout.component.html',
    styleUrls: ['./content-layout.component.scss']
})

export class ContentLayoutComponent  {

}


// WEBPACK FOOTER //
// ./src/app/layouts/content/content-layout.component.ts